const OrderType = Object.freeze({
  replacement: { key: "Replacement", value: (t) => t("form.order_type.replecement_text") },
  free: { key: "Free", value: (t) => t("form.order_type.free_text") }
});

export { OrderType };
